import React from "react";
import "./EALink.scss";
import { Link } from "react-router-dom";

interface IProps {
  to: string;
  title: string;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  color?: "primary" | "secondary";
  className?: string;
}

const EALink: React.FC<IProps> = ({ to, title, startIcon, endIcon, color = "primary", className = "" }) => {
  const isExternal = to.startsWith("http") || to.startsWith("www");
  const linkClasses = `custom-link custom-link--${color} ${className}`;

  if (isExternal) {
    // Zewnętrzny link - otwieramy w nowej karcie
    return (
      <a href={to} className={linkClasses} target="_blank" rel="noopener noreferrer">
        {startIcon && <span className="custom-link__icon custom-link__icon--start">{startIcon}</span>}
        {title}
        {endIcon && <span className="custom-link__icon custom-link__icon--end">{endIcon}</span>}
      </a>
    );
  }

  // Wewnętrzny link - korzystamy z react-router-dom
  return (
    <Link to={to} className={linkClasses}>
      {startIcon && <span className="custom-link__icon custom-link__icon--start">{startIcon}</span>}
      {title}
      {endIcon && <span className="custom-link__icon custom-link__icon--end">{endIcon}</span>}
    </Link>
  );
};

export default EALink;
